<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus">
        <form class="modal-dialog modal-md" role="document" @click="stopPropagationEvent" @submit="confirm">
            <div class="modal-header">
                <div class="modal-title">{{ title }}</div>
                <button type="button" class="modal-close-btn" :title="$t('Close')" @click="close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ message }}</p>
                <div class="form-group">
                    <label>{{ $t("Wallet password") }}:</label>
                    <PasswordInput v-model:val="password" name="wallet-password" :auto-focus="true"></PasswordInput>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" :disabled="!password" class="btn btn-mr" :class="{ 'btn-primary': !danger, 'btn-danger': danger }">
                    <i class="fas fa-check"></i> {{ $t("Confirm") }}
                </button>
                <button type="button" class="btn btn-primary" @click="close">
                    {{ $t("Cancel") }}
                </button>
            </div>
        </form>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "../../utils/v-model";
import PasswordInput from "../utils/PasswordInput.vue";

export default defineComponent({
    components: {
        PasswordInput,
    },
    name: "WalletConfirmationModal",
    emits: ["update:display", "confirm"],
    props: {
        display: Boolean,
        title: String,
        message: String,
        danger: Boolean,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data: function () {
        return {
            password: "",
        };
    },
    methods: {
        close: function () {
            this.$closeModal();
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.close();
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },

        confirm: function (e?: Event) {
            if (e) {
                e.preventDefault();
            }

            this.close();
            this.$emit("confirm", this.password);
        },
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style></style>
